import { DefaultInvoiceSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/InvoiceSortFilterType";
import { type FilterValues } from "components/filters/FilterContext";
import { mapBookkeepingFilterToInstruction, mapCompanyFilterToInstruction, mapContactFilterToInstruction, mapCostCenterFilterToInstruction, mapInvoiceProgressFilterToInstruction, mapKeywordFilterToInstruction, mapOnlyMySelectionFilterToInstruction, mapOwnersFilterToInstruction, mapPeriodFilterToInstruction, mapResponseToBookkeepingFilter, mapResponseToCompanyFilter, mapResponseToContactFilter, mapResponseToCostCenterFilter, mapResponseToInvoiceProgressFilter, mapResponseToKeywordFilter, mapResponseToOnlyMySelectionFilter, mapResponseToOwnerFilter, mapResponseToPeriodFilter, mapResponseToStatusFilter, mapStatusFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListInvoiceInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  companyIds: mapCompanyFilterToInstruction(filter.company),
  contactIds: mapContactFilterToInstruction(filter.contact),
  lifeCycle: mapInvoiceProgressFilterToInstruction(filter.invoiceProgress),
  bookkeepingIds: mapBookkeepingFilterToInstruction(filter.bookkeepings),
  costCenterIds: mapCostCenterFilterToInstruction(filter.costCenter),
  statuses: mapStatusFilterToInstruction(filter.statuses),
  ownerUserIds: mapOwnersFilterToInstruction(filter.owners),
  period: mapPeriodFilterToInstruction(filter.period),
  order: filter.invoiceSort.sortOption.value,
  page,
  perPage,
  onlyMySelection: mapOnlyMySelectionFilterToInstruction(filter.onlyMySelection),
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListInvoiceFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  company: mapResponseToCompanyFilter(response.companies),
  contact: mapResponseToContactFilter(response.contacts),
  invoiceProgress: mapResponseToInvoiceProgressFilter(response.lifeCycle),
  bookkeepings: mapResponseToBookkeepingFilter(response.bookkeepings),
  costCenter: mapResponseToCostCenterFilter(response.costCenters),
  statuses: mapResponseToStatusFilter(response.statuses, values.statuses),
  owners: mapResponseToOwnerFilter(response.ownerUsers),
  period: mapResponseToPeriodFilter(response.period),
  invoiceSort: {
    sortOption: (response.order !== "documentNumberDesc")
      ? getSortOption(response.order)
      : getSortOption(DefaultInvoiceSortFilter)
  },
  onlyMySelection: mapResponseToOnlyMySelectionFilter(response.onlyMySelection)
});